var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.hasOptions
    ? _c(
        "div",
        {
          staticClass: "mb-4",
          attrs: {
            "data-selected-speciality-id": _vm.selectValue.id,
            "data-appointment-type-redirect": _vm.appointmentTypeRedirect,
          },
        },
        [
          _c("SelectModuleButton", {
            class: _vm.isMobile ? "py-2" : "py-1",
            attrs: { title: _vm.selectValue.name },
            on: { click: _vm.handleClickSelect },
          }),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }